// src/composables/useToast.js
// Unified toast composable — delegates to vue-toastification.
// All files should import from here, never directly from vue-toastification.
import { useToast as useVueToast } from 'vue-toastification'
import { eventBus } from '@/utils/eventBus'

let initialized = false

export function useToast() {
  const vueToast = useVueToast()

  const show = (message, type = 'success') => {
    if (type === 'error') {
      vueToast.error(message)
    } else if (type === 'info') {
      vueToast.info(message)
    } else if (type === 'warning') {
      vueToast.warning(message)
    } else {
      vueToast.success(message)
    }
  }

  const success = (message, opts) => vueToast.success(message, opts)
  const error = (message, opts) => vueToast.error(message, opts)
  const info = (message, opts) => vueToast.info(message, opts)
  const warning = (message, opts) => vueToast.warning(message, opts)
  const dismiss = () => vueToast.clear()
  const clear = () => vueToast.clear()

  // Global event bus listener (register once)
  if (!initialized) {
    initialized = true
    eventBus.on('toast', ({ message, type = 'success' }) => {
      show(message, type)
    })
  }

  return { show, success, error, info, warning, dismiss, clear }
}
